import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['source', 'icon']
  static values = { copied: { type: String, default: 'Copied!' } }

  copy() {
    const text = this.sourceTarget.textContent.trim()
    navigator.clipboard.writeText(text).then(() => {
      this.showFeedback()
    })
  }

  showFeedback() {
    const btn = this.iconTarget
    const original = btn.innerHTML

    btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="14" height="14"><path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd"/></svg>'
    btn.classList.add('dg-copy-success')
    btn.setAttribute('data-bs-original-title', this.copiedValue)

    const tooltip = new bootstrap.Tooltip(btn, {
      trigger: 'manual',
      placement: 'top',
    })
    tooltip.show()

    setTimeout(() => {
      tooltip.dispose()
      btn.innerHTML = original
      btn.classList.remove('dg-copy-success')
    }, 1500)
  }
}
